import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { loadReportById } from "./loadReport";

/**
 * Supplies the report for a review page. Prefers the enriched report handed
 * over in router state (fast path from the Testrapporter list), and falls back
 * to rebuilding it from the :executionId in the URL on a hard refresh, when
 * router state is gone. Returns { report, setReport, loading } — setReport lets
 * a page reflect an in-place status change (e.g. after "Påbörja granskning").
 */
export default function useReviewReport() {
  const { state } = useLocation();
  const { executionId } = useParams();

  const [report, setReport] = useState(state?.report ?? null);
  // Only "loading" when we actually have to fetch (no state + we have an id).
  const [loading, setLoading] = useState(!state?.report && !!executionId);

  useEffect(() => {
    if (state?.report) {
      setReport(state.report);
      setLoading(false);
      return;
    }
    if (!executionId) return;

    let cancelled = false;
    setLoading(true);
    loadReportById(executionId)
      .then((r) => { if (!cancelled) setReport(r); })
      .catch((err) => { if (!cancelled) console.error("Could not load report:", err); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [state?.report, executionId]);

  return { report, setReport, loading };
}
